// firebase.js
import { initializeApp } from "firebase/app";
import { getAuth, OAuthProvider } from "firebase/auth";
import { getFirestore, initializeFirestore } from "firebase/firestore";

// --- Your Firebase config ---
const firebaseConfig = {
  apiKey: "AIzaSyCogzjq7BGyEzM8TVf23S2VmhO38PcqH1c",
  authDomain: "interview-7d0b2.firebaseapp.com",
  projectId: "interview-7d0b2",
  storageBucket: "interview-7d0b2.appspot.com",
  messagingSenderId: "141496720652",
  appId: "1:141496720652:web:5a3ccdee8171da062abd29",
  measurementId: "G-KH4CEN26VN"
};

// --- Initialize Firebase ---
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

// --- Try normal Firestore first ---
let database;
try {
  database = getFirestore(app);
} catch (e) {
  console.warn("⚠️ WebChannel failed, falling back to long-polling:", e);
  database = initializeFirestore(app, {
    experimentalForceLongPolling: true,
    useFetchStreams: false
  });
}

export { database };

// --- Microsoft OAuth (unchanged) ---
const microsoftProvider = new OAuthProvider("microsoft.com");
microsoftProvider.setCustomParameters({
  prompt: "consent",
  tenant: "a28e6f27-7914-40eb-8b05-dc4a98d7b241",
});

export { microsoftProvider };
